



// import React, { useState, useEffect, useRef } from 'react';
// import { collection, query, getDocs, where, orderBy, doc, getDoc } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig';
// import MovingAdvertisement from './MovingAdvertisement';
// import FeaturedProducts from '../ComponentsHub/FeaturedProducts';
// import Testimonials from '../ComponentsHub/Testimonials';
// import LiveHackathons from '../ComponentsHub/LiveHackathons';
// import ProjectShowcase from '../ComponentsHub/ProjectShowcase';
// import './DesignMakersHub.css';

// export default function DesignMakersHub() {
//   const [activeSlide1, setActiveSlide1] = useState(0);
//   const [currentCategory1, setCurrentCategory1] = useState(null); // Start with null to show all products
//   const [activeSection, setActiveSection] = useState('featured');
//   const [categories1, setCategories1] = useState([]);
//   const [categoryBanners1, setCategoryBanners1] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Refs for scrolling
//   const featuredRef = useRef(null);
//   const testimonialsRef = useRef(null);
//   const hackathonsRef = useRef(null);
//   const showcaseRef = useRef(null);

//   // Navigation sections
//   const navSections = [
//     // { id: 'categories', name: 'Featured Products', ref: featuredRef },
//     { id: 'testimonials', name: 'Testimonials', ref: testimonialsRef },
//     { id: 'hackathons', name: 'Live Hackathons', ref: hackathonsRef },
//     { id: 'showcase', name: 'Project Showcase', ref: showcaseRef },
//   ];

//   // Fetch categories from Firestore
//   useEffect(() => {
//     const fetchCategories = async () => {
//       setLoading(true);
//       try {
//         const categoriesQuery = query(
//           collection(db, 'designCategories'),
//           orderBy('name')
//         );

//         const querySnapshot = await getDocs(categoriesQuery);

//         if (querySnapshot.empty) {
//           // Use default categories if none in database
//           setCategories1(getDefaultCategories());
//         } else {
//           const fetchedCategories = querySnapshot.docs.map(doc => ({
//             id: doc.id,
//             ...doc.data()
//           }));

//           setCategories1(fetchedCategories);
//         }
//       } catch (err) {
//         console.error('Error fetching categories:', err);
//         setError('Failed to load categories');
//         // Use default categories in case of error
//         setCategories1(getDefaultCategories());
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCategories();
//   }, []);

//   // Default categories as fallback
//   const getDefaultCategories = () => {
//     return [
//       {
//         id: 'fast-prototyping',
//         name: 'Fast Prototyping',
//         icon: '⚡',
//         description: 'Quick turnaround for your prototype needs',
//         slug: 'fast-prototyping'
//       },
//       {
//         id: 'pcb-manufacturing',
//         name: 'PCB Manufacturing',
//         icon: '🔌',
//         description: 'Professional PCB fabrication services',
//         slug: 'pcb-manufacturing'
//       },
//       {
//         id: '3d-printing',
//         name: '3D Printing',
//         icon: '🖨️',
//         description: 'Bring your 3D designs to life',
//         slug: '3d-printing'
//       },
//       {
//         id: 'laser-cutting',
//         name: 'Laser Cutting',
//         icon: '✂️',
//         description: 'Precision laser cutting for your projects',
//         slug: 'laser-cutting'
//       },
//       {
//         id: 'custom-battery',
//         name: 'Custom Battery Pack',
//         icon: '🔋',
//         description: 'Tailored battery solutions for any application',
//         slug: 'custom-battery'
//       },
//       {
//         id: 'iot-components',
//         name: 'IoT Components',
//         icon: '📱',
//         description: 'Connected devices and components',
//         slug: 'iot-components'
//       }
//     ];
//   };

//   // Default banners as fallback
//   const getDefaultBanners = (categoryId) => {
//     // Common banners for "All Products" view
//     const allProductsBanners = [
//       {
//         id: 'all-1',
//         title: 'Design Makers Hub',
//         description: 'Your one-stop solution for all design and manufacturing needs',
//         imageUrl: 'https://t3.ftcdn.net/jpg/08/89/37/44/360_F_889374453_zjxxI22foLWLMf5cRSnFbQrlgMI9oNI4.jpg',
//         ctaText: 'Explore Services'
//       },
//       {
//         id: 'all-2',
//         title: 'Quality Manufacturing',
//         description: 'Professional services with industry-leading precision',
//         imageUrl: 'https://www.airproducts.com/-/media/images/1440x810/masthead/474499852-circuit-board-16x9.jpg?as=0&w=1439&hash=391910ACF9BF8579F523E39FF4A54DAA',
//         ctaText: 'Get Started'
//       }
//     ];

//     const defaultBannersMap = {
//       'fast-prototyping': [
//         {
//           id: 1,
//           title: 'Rapid Prototyping Solutions',
//           description: 'Get your ideas from concept to prototype in days',
//           imageUrl: 'https://t3.ftcdn.net/jpg/08/89/37/44/360_F_889374453_zjxxI22foLWLMf5cRSnFbQrlgMI9oNI4.jpg',
//           ctaText: 'Learn More'
//         },
//         {
//           id: 2,
//           title: 'Express Design Services',
//           description: 'Professional design assistance for quick turnaround',
//           imageUrl: 'https://media.istockphoto.com/id/1327735635/photo/business-and-technology-concept-communication-network-businesswoman-typing-on-a-laptop.jpg?s=612x612&w=0&k=20&c=bJmX8r0A9Rrn5hXTfvE6ls1qt8tv27h7SudAD_YAXlI=',
//           ctaText: 'Get Started'
//         }
//       ],
//       'pcb-manufacturing': [
//         {
//           id: 1,
//           title: 'Professional PCB Manufacturing',
//           description: 'High-quality PCB fabrication with industry-leading precision',
//           imageUrl: 'https://www.airproducts.com/-/media/images/1440x810/masthead/474499852-circuit-board-16x9.jpg?as=0&w=1439&hash=391910ACF9BF8579F523E39FF4A54DAA',
//           ctaText: 'Order Now'
//         },
//         {
//           id: 2,
//           title: 'PCB Assembly Services',
//           description: 'Full turnkey PCB assembly with component sourcing',
//           imageUrl: 'https://i0.wp.com/fusionele.com/wp-content/uploads/2019/01/page_image.jpg?fit=740%2C360&ssl=1',
//           ctaText: 'Get Quote'
//         }
//       ],
//       '3d-printing': [
//         {
//           id: 1,
//           title: '3D Printing Services',
//           description: 'Advanced 3D printing technologies for any project',
//           imageUrl: 'https://5.imimg.com/data5/SELLER/Default/2024/9/448804591/GX/NI/RR/138050562/fdm-3d-printing-service.jpg',
//           ctaText: 'Upload Model'
//         },
//         {
//           id: 2,
//           title: 'Multi-Material 3D Printing',
//           description: 'Create complex parts with multiple materials',
//           imageUrl: 'https://www.forwardpathway.us/wp-content/uploads/2025/04/multi_material_3d_printing_innovation.jpg',
//           ctaText: 'Explore Options'
//         }
//       ],
//       'laser-cutting': [
//         {
//           id: 1,
//           title: 'Precision Laser Cutting',
//           description: 'Accurate cutting for various materials and thicknesses',
//           imageUrl: 'https://phshirt.com/wp-content/uploads/2021/03/laser-cut-1.jpg',
//           ctaText: 'Submit Design'
//         },
//         {
//           id: 2,
//           title: 'Laser Engraving Services',
//           description: 'Detailed engraving for personalization and marking',
//           imageUrl: 'https://tiimg.tistatic.com/fp/1/008/575/laser-cutting-services-673.jpg',
//           ctaText: 'Learn More'
//         }
//       ],
//       'custom-battery': [
//         {
//           id: 1,
//           title: 'Custom Battery Solutions',
//           description: 'Tailored battery packs for your specific requirements',
//           imageUrl: 'https://global.ariseplay.com/amg/www.thisdaylive.com/uploads/f-1.png',
//           ctaText: 'Request Design'
//         },
//         {
//           id: 2,
//           title: 'Battery Testing & Certification',
//           description: 'Comprehensive testing to ensure safety and performance',
//           imageUrl: 'https://forocuatro.tv/wp-content/uploads/2025/01/compressed_img-UugcIyY3evQtVJn1Y8P34Ef7.png',
//           ctaText: 'Learn More'
//         }
//       ],
//       'iot-components': [
//         {
//           id: 1,
//           title: 'Smart Sensors & Modules',
//           description: 'Wide range of sensors for any connected application',
//           imageUrl: 'https://www.i-scoop.eu/wp-content/uploads/2021/09/Smart-sensor-concept.jpg',
//           ctaText: 'View Catalog'
//         },
//         {
//           id: 2,
//           title: 'IoT Development Kits',
//           description: 'Complete kits to kickstart your IoT projects',
//           imageUrl: 'https://media.licdn.com/dms/image/v2/D5612AQHet9nZr_QBqw/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1681225306305?e=2147483647&v=beta&t=ejkwpJ9g69T5SsemKjLrVsdWCVBnnlxfgGuwpSVy4rg',
//           ctaText: 'Shop Now'
//         }
//       ],
//       'all': allProductsBanners
//     };

//     return defaultBannersMap[categoryId] || allProductsBanners;
//   };

//   // Fetch banners for the current category
//   useEffect(() => {
//     const fetchBanners = async () => {
//       // Get the category key to use (either the current category or 'all' for null)
//       const categoryKey = currentCategory1 || 'all';

//       // If we already have banners for this category, no need to fetch again
//       if (categoryBanners1[categoryKey] && categoryBanners1[categoryKey].length > 0) {
//         return;
//       }

//       try {
//         if (currentCategory1) {
//           // First try to get banners from categoryBanners collection
//           const bannersQuery = query(
//             collection(db, 'categoryBanners'),
//             where('categoryId', '==', currentCategory1)
//           );

//           const querySnapshot = await getDocs(bannersQuery);

//           if (!querySnapshot.empty) {
//             const fetchedBanners = querySnapshot.docs.map(doc => ({
//               id: doc.id,
//               ...doc.data()
//             }));

//             setCategoryBanners1(prev => ({
//               ...prev,
//               [currentCategory1]: fetchedBanners
//             }));
//           } else {
//             // If no results, try directly from the categoryBanners collection with specific document ID
//             try {
//               const directBannerDoc = await getDoc(doc(db, 'categoryBanners', currentCategory1));

//               if (directBannerDoc.exists()) {
//                 const bannerData = directBannerDoc.data();
//                 // Check if we have an array of banners or a single banner object
//                 const bannerArray = Array.isArray(bannerData) ? bannerData : [bannerData];

//                 setCategoryBanners1(prev => ({
//                   ...prev,
//                   [currentCategory1]: bannerArray
//                 }));
//               } else {
//                 // If still no results, use default banners
//                 setCategoryBanners1(prev => ({
//                   ...prev,
//                   [currentCategory1]: getDefaultBanners(currentCategory1)
//                 }));
//               }
//             } catch (directErr) {
//               console.error('Error fetching direct banner:', directErr);
//               setCategoryBanners1(prev => ({
//                 ...prev,
//                 [currentCategory1]: getDefaultBanners(currentCategory1)
//               }));
//             }
//           }
//         } else {
//           // For "All Products", use default all banners
//           setCategoryBanners1(prev => ({
//             ...prev,
//             'all': getDefaultBanners('all')
//           }));
//         }

//         // Reset active slide when category changes
//         setActiveSlide1(0);
//       } catch (err) {
//         console.error('Error fetching banners:', err);
//         // Use default banners in case of error
//         setCategoryBanners1(prev => ({
//           ...prev,
//           [categoryKey]: getDefaultBanners(categoryKey)
//         }));
//       }
//     };

//     fetchBanners();
//   }, [currentCategory1]);

//   // Auto rotate banners - updated to handle both category and "all" banners
//   useEffect(() => {
//     const categoryKey = currentCategory1 || 'all';
//     const banners = categoryBanners1[categoryKey];

//     if (!banners || banners.length <= 1) return;

//     const interval = setInterval(() => {
//       setActiveSlide1((prev) => (prev + 1) % banners.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [currentCategory1, categoryBanners1]);

//   // Handle category selection
//   const handleCategorySelect1 = (categoryId) => {
//     const category = categories1.find(cat => cat.id === categoryId);
//     setCurrentCategory1(category ? category.slug || category.id : null); // Use slug if available, fallback to id
//     setActiveSlide1(0);
//   };

//   // Scroll to section function
//   const scrollToSection = (sectionId) => {
//     const section = navSections.find(section => section.id === sectionId);
//     if (section && section.ref.current) {
//       section.ref.current.scrollIntoView({ behavior: 'smooth' });
//       setActiveSection(sectionId);
//     }
//   };

//   // Loading state
//   if (loading && !currentCategory1) {
//     return (
//       <div className="design-makers-hub1 loading">
//         <div className="loading-spinner"></div>
//         <p>Loading Design Makers Hub...</p>
//       </div>
//     );
//   }

//   // Helper function to get the banners to display
//   const getBannersToDisplay = () => {
//     const categoryKey = currentCategory1 || 'all';
//     return categoryBanners1[categoryKey] || getDefaultBanners(categoryKey);
//   };

//   // Helper function to get the section title
//   const getBannerSectionTitle = () => {
//     if (currentCategory1) {
//       const categoryName = categories1.find(cat => (cat.slug || cat.id) === currentCategory1)?.name;
//       return `${categoryName || 'Featured'} Solutions`;
//     }
//     return 'Featured Solutions';
//   };

//   return (
//     <div className="design-makers-hub1">

//       <div className='dmh-sticky-wrapper'>
//         <MovingAdvertisement />
//       </div>

//       <div className="dmh-header1">
//         <div className="dmh-logo1">
//           <div className="logo-text1">
//             <span className="logo-cart1">Design</span>
//             <span className="logo-india1">Makers Hub</span>
//           </div>
//         </div>

//         {/* Navigation Bar */}
//         <div className="dmh-nav-bar">
//           {navSections.map(section => (
//             <div
//               key={section.id}
//               className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
//               onClick={() => scrollToSection(section.id)}
//             >
//               <span>{section.name}</span>
//               <span className="nav-arrow">↓</span>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="dmh-content1">
//         {/* Category Banner Section - now always displays banners */}
//         {/* <div className="banner-container1">
//           <h2 className="section-title1">
//             {getBannerSectionTitle()}
//           </h2>
//           <div className="banner-slider1">
//             <div className="slides-container1" style={{
//               transform: `translateX(-${activeSlide1 * 100}%)`
//             }}>
//               {getBannersToDisplay().map((banner, index) => (
//                 <div
//                   key={banner.id || index}
//                   className={`banner-slide1 ${index === activeSlide1 ? 'active1' : ''}`}
//                 >
//                   <div className="banner-image1" style={{
//                     backgroundImage: `url(${banner.imageUrl})`
//                   }}>
//                     <div className="banner-content1">
//                       <h3 className="banner-title1">{banner.title}</h3>
//                       <p className="banner-description1">{banner.description}</p>
//                       <button className="banner-cta1">{banner.ctaText || 'Learn More'}</button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {getBannersToDisplay().length > 1 && (
//               <div className="slider-controls1">
//                 {getBannersToDisplay().map((_, index) => (
//                   <button
//                     key={index}
//                     className={`dot-indicator1 ${index === activeSlide1 ? 'active1' : ''}`}
//                     onClick={() => setActiveSlide1(index)}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         </div> */}

//         <div className="categories-container1">
//           <h2 className="section-title1">Categories</h2>
//           <div className="categories-grid1">
//             {/* <div
//               key="all"
//               className={`category-card1 ${!currentCategory1 ? 'active1' : ''}`}
//               onClick={() => setCurrentCategory1(null)}
//             >
//               <div className="category-icon1">🌐</div>
//               <h3 className="category-name1">All Products</h3>
//               <p className="category-description1">View all featured products</p>
//             </div> */}
//             {categories1.map(category => (
//               <div
//                 key={category.id}
//                 className={`category-card1 ${currentCategory1 === (category.slug || category.id) ? 'active1' : ''}`}
//                 onClick={() => handleCategorySelect1(category.id)}
//               >
//                 <div className="category-icon1">{category.icon}</div>
//                 <h3 className="category-name1">{category.name}</h3>
//                 <p className="category-description1">{category.description}</p>
//               </div>
//             ))}

//           </div>
//         </div>

//         {/* Featured Products component */}
//         <div ref={featuredRef} id="featured-section">
//           <FeaturedProducts currentCategory={currentCategory1} />
//         </div>

//         {/* Testimonials component */}
//         <div ref={testimonialsRef} id="testimonials-section">
//           <Testimonials />
//         </div>

//         {/* Live Hackathons component */}
//         <div ref={hackathonsRef} id="hackathons-section">
//           <LiveHackathons />
//         </div>

//         {/* Project Showcase component */}
//         <div ref={showcaseRef} id="showcase-section">
//           <ProjectShowcase />
//         </div>
//       </div>
//     </div>
//   );
// }






import React, { useState, useEffect, useRef } from 'react';
import { collection, query, getDocs, where, orderBy, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import MovingAdvertisement from './MovingAdvertisement';
import FeaturedProducts from '../ComponentsHub/FeaturedProducts';
import Testimonials from '../ComponentsHub/Testimonials';
import LiveHackathons from '../ComponentsHub/LiveHackathons';
import ProjectShowcase from '../ComponentsHub/ProjectShowcase';
import './DesignMakersHub.css';

export default function DesignMakersHub() {
  const [activeSlide1, setActiveSlide1] = useState(0);
  const [currentCategory1, setCurrentCategory1] = useState('3d-printing'); // Set default to 3D Printing
  const [activeSection, setActiveSection] = useState('featured');
  const [categories1, setCategories1] = useState([]);
  const [categoryBanners1, setCategoryBanners1] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Refs for scrolling
  const featuredRef = useRef(null);
  const testimonialsRef = useRef(null);
  const hackathonsRef = useRef(null);
  const showcaseRef = useRef(null);

  // Navigation sections
  const navSections = [
    // { id: 'categories', name: 'Featured Products', ref: featuredRef },
    { id: 'testimonials', name: 'Testimonials', ref: testimonialsRef },
    { id: 'hackathons', name: 'Live Hackathons', ref: hackathonsRef },
    { id: 'showcase', name: 'Project Showcase', ref: showcaseRef },
  ];

  // Fetch categories from Firestore
  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const categoriesQuery = query(
          collection(db, 'designCategories'),
          orderBy('name')
        );

        const querySnapshot = await getDocs(categoriesQuery);

        if (querySnapshot.empty) {
          // Use default categories if none in database
          setCategories1(getDefaultCategories());
        } else {
          const fetchedCategories = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));

          setCategories1(fetchedCategories);
        }
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError('Failed to load categories');
        // Use default categories in case of error
        setCategories1(getDefaultCategories());
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Default categories as fallback
  const getDefaultCategories = () => {
    return [
      {
        id: 'fast-prototyping',
        name: 'Fast Prototyping',
        icon: '⚡',
        description: 'Quick turnaround for your prototype needs',
        slug: 'fast-prototyping'
      },
      {
        id: 'pcb-manufacturing',
        name: 'PCB Manufacturing',
        icon: '🔌',
        description: 'Professional PCB fabrication services',
        slug: 'pcb-manufacturing'
      },
      {
        id: '3d-printing',
        name: '3D Printing',
        icon: '🖨️',
        description: 'Bring your 3D designs to life',
        slug: '3d-printing'
      },
      {
        id: 'laser-cutting',
        name: 'Laser Cutting',
        icon: '✂️',
        description: 'Precision laser cutting for your projects',
        slug: 'laser-cutting'
      },
      {
        id: 'custom-battery',
        name: 'Custom Battery Pack',
        icon: '🔋',
        description: 'Tailored battery solutions for any application',
        slug: 'custom-battery'
      },
      {
        id: 'iot-components',
        name: 'IoT Components',
        icon: '📱',
        description: 'Connected devices and components',
        slug: 'iot-components'
      }
    ];
  };

  // Default banners as fallback
  const getDefaultBanners = (categoryId) => {
    // Common banners for "All Products" view
    const allProductsBanners = [
      {
        id: 'all-1',
        title: 'Design Makers Hub',
        description: 'Your one-stop solution for all design and manufacturing needs',
        imageUrl: 'https://t3.ftcdn.net/jpg/08/89/37/44/360_F_889374453_zjxxI22foLWLMf5cRSnFbQrlgMI9oNI4.jpg',
        ctaText: 'Explore Services'
      },
      {
        id: 'all-2',
        title: 'Quality Manufacturing',
        description: 'Professional services with industry-leading precision',
        imageUrl: 'https://www.airproducts.com/-/media/images/1440x810/masthead/474499852-circuit-board-16x9.jpg?as=0&w=1439&hash=391910ACF9BF8579F523E39FF4A54DAA',
        ctaText: 'Get Started'
      }
    ];

    const defaultBannersMap = {
      'fast-prototyping': [
        {
          id: 1,
          title: 'Rapid Prototyping Solutions',
          description: 'Get your ideas from concept to prototype in days',
          imageUrl: 'https://t3.ftcdn.net/jpg/08/89/37/44/360_F_889374453_zjxxI22foLWLMf5cRSnFbQrlgMI9oNI4.jpg',
          ctaText: 'Learn More'
        },
        {
          id: 2,
          title: 'Express Design Services',
          description: 'Professional design assistance for quick turnaround',
          imageUrl: 'https://media.istockphoto.com/id/1327735635/photo/business-and-technology-concept-communication-network-businesswoman-typing-on-a-laptop.jpg?s=612x612&w=0&k=20&c=bJmX8r0A9Rrn5hXTfvE6ls1qt8tv27h7SudAD_YAXlI=',
          ctaText: 'Get Started'
        }
      ],
      'pcb-manufacturing': [
        {
          id: 1,
          title: 'Professional PCB Manufacturing',
          description: 'High-quality PCB fabrication with industry-leading precision',
          imageUrl: 'https://www.airproducts.com/-/media/images/1440x810/masthead/474499852-circuit-board-16x9.jpg?as=0&w=1439&hash=391910ACF9BF8579F523E39FF4A54DAA',
          ctaText: 'Order Now'
        },
        {
          id: 2,
          title: 'PCB Assembly Services',
          description: 'Full turnkey PCB assembly with component sourcing',
          imageUrl: 'https://i0.wp.com/fusionele.com/wp-content/uploads/2019/01/page_image.jpg?fit=740%2C360&ssl=1',
          ctaText: 'Get Quote'
        }
      ],
      '3d-printing': [
        {
          id: 1,
          title: '3D Printing Services',
          description: 'Advanced 3D printing technologies for any project',
          imageUrl: 'https://5.imimg.com/data5/SELLER/Default/2024/9/448804591/GX/NI/RR/138050562/fdm-3d-printing-service.jpg',
          ctaText: 'Upload Model'
        },
        {
          id: 2,
          title: 'Multi-Material 3D Printing',
          description: 'Create complex parts with multiple materials',
          imageUrl: 'https://www.forwardpathway.us/wp-content/uploads/2025/04/multi_material_3d_printing_innovation.jpg',
          ctaText: 'Explore Options'
        }
      ],
      'laser-cutting': [
        {
          id: 1,
          title: 'Precision Laser Cutting',
          description: 'Accurate cutting for various materials and thicknesses',
          imageUrl: 'https://phshirt.com/wp-content/uploads/2021/03/laser-cut-1.jpg',
          ctaText: 'Submit Design'
        },
        {
          id: 2,
          title: 'Laser Engraving Services',
          description: 'Detailed engraving for personalization and marking',
          imageUrl: 'https://tiimg.tistatic.com/fp/1/008/575/laser-cutting-services-673.jpg',
          ctaText: 'Learn More'
        }
      ],
      'custom-battery': [
        {
          id: 1,
          title: 'Custom Battery Solutions',
          description: 'Tailored battery packs for your specific requirements',
          imageUrl: 'https://global.ariseplay.com/amg/www.thisdaylive.com/uploads/f-1.png',
          ctaText: 'Request Design'
        },
        {
          id: 2,
          title: 'Battery Testing & Certification',
          description: 'Comprehensive testing to ensure safety and performance',
          imageUrl: 'https://forocuatro.tv/wp-content/uploads/2025/01/compressed_img-UugcIyY3evQtVJn1Y8P34Ef7.png',
          ctaText: 'Learn More'
        }
      ],
      'iot-components': [
        {
          id: 1,
          title: 'Smart Sensors & Modules',
          description: 'Wide range of sensors for any connected application',
          imageUrl: 'https://www.i-scoop.eu/wp-content/uploads/2021/09/Smart-sensor-concept.jpg',
          ctaText: 'View Catalog'
        },
        {
          id: 2,
          title: 'IoT Development Kits',
          description: 'Complete kits to kickstart your IoT projects',
          imageUrl: 'https://media.licdn.com/dms/image/v2/D5612AQHet9nZr_QBqw/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1681225306305?e=2147483647&v=beta&t=ejkwpJ9g69T5SsemKjLrVsdWCVBnnlxfgGuwpSVy4rg',
          ctaText: 'Shop Now'
        }
      ],
      'all': allProductsBanners
    };

    return defaultBannersMap[categoryId] || allProductsBanners;
  };

  // Fetch banners for the current category
  useEffect(() => {
    const fetchBanners = async () => {
      // Get the category key to use (either the current category or 'all' for null)
      const categoryKey = currentCategory1 || 'all';

      // If we already have banners for this category, no need to fetch again
      if (categoryBanners1[categoryKey] && categoryBanners1[categoryKey].length > 0) {
        return;
      }

      try {
        if (currentCategory1) {
          // First try to get banners from categoryBanners collection
          const bannersQuery = query(
            collection(db, 'categoryBanners'),
            where('categoryId', '==', currentCategory1)
          );

          const querySnapshot = await getDocs(bannersQuery);

          if (!querySnapshot.empty) {
            const fetchedBanners = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));

            setCategoryBanners1(prev => ({
              ...prev,
              [currentCategory1]: fetchedBanners
            }));
          } else {
            // If no results, try directly from the categoryBanners collection with specific document ID
            try {
              const directBannerDoc = await getDoc(doc(db, 'categoryBanners', currentCategory1));

              if (directBannerDoc.exists()) {
                const bannerData = directBannerDoc.data();
                // Check if we have an array of banners or a single banner object
                const bannerArray = Array.isArray(bannerData) ? bannerData : [bannerData];

                setCategoryBanners1(prev => ({
                  ...prev,
                  [currentCategory1]: bannerArray
                }));
              } else {
                // If still no results, use default banners
                setCategoryBanners1(prev => ({
                  ...prev,
                  [currentCategory1]: getDefaultBanners(currentCategory1)
                }));
              }
            } catch (directErr) {
              console.error('Error fetching direct banner:', directErr);
              setCategoryBanners1(prev => ({
                ...prev,
                [currentCategory1]: getDefaultBanners(currentCategory1)
              }));
            }
          }
        } else {
          // For "All Products", use default all banners
          setCategoryBanners1(prev => ({
            ...prev,
            'all': getDefaultBanners('all')
          }));
        }

        // Reset active slide when category changes
        setActiveSlide1(0);
      } catch (err) {
        console.error('Error fetching banners:', err);
        // Use default banners in case of error
        setCategoryBanners1(prev => ({
          ...prev,
          [categoryKey]: getDefaultBanners(categoryKey)
        }));
      }
    };

    fetchBanners();
  }, [currentCategory1]);

  // Auto rotate banners - updated to handle both category and "all" banners
  useEffect(() => {
    const categoryKey = currentCategory1 || 'all';
    const banners = categoryBanners1[categoryKey];

    if (!banners || banners.length <= 1) return;

    const interval = setInterval(() => {
      setActiveSlide1((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentCategory1, categoryBanners1]);

  // Handle category selection
  const handleCategorySelect1 = (categoryId) => {
    const category = categories1.find(cat => cat.id === categoryId);
    setCurrentCategory1(category ? category.slug || category.id : null); // Use slug if available, fallback to id
    setActiveSlide1(0);
  };

  // Scroll to section function
  const scrollToSection = (sectionId) => {
    const section = navSections.find(section => section.id === sectionId);
    if (section && section.ref.current) {
      section.ref.current.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  // Loading state
  if (loading && !categories1.length) {
    return (
      <div className="design-makers-hub1 loading">
        <div className="loading-spinner"></div>
        <p>Loading Design Makers Hub...</p>
      </div>
    );
  }

  // Helper function to get the banners to display
  const getBannersToDisplay = () => {
    const categoryKey = currentCategory1 || 'all';
    return categoryBanners1[categoryKey] || getDefaultBanners(categoryKey);
  };

  // Helper function to get the section title
  const getBannerSectionTitle = () => {
    if (currentCategory1) {
      const categoryName = categories1.find(cat => (cat.slug || cat.id) === currentCategory1)?.name;
      return `${categoryName || 'Featured'} Solutions`;
    }
    return 'Featured Solutions';
  };

  return (
    <div className="design-makers-hub1">

      <div className='dmh-sticky-wrapper'>
        <MovingAdvertisement />
      </div>

      <div className="dmh-header1">
        <div className="dmh-logo1">
          <div className="logo-text1">
            <span className="logo-cart1">Design</span>
            <span className="logo-india1">Makers Hub</span>
          </div>
        </div>

        {/* Navigation Bar */}
        <div className="dmh-nav-bar">
          {navSections.map(section => (
            <div
              key={section.id}
              className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => scrollToSection(section.id)}
            >
              <span>{section.name}</span>
              <span className="nav-arrow">↓</span>
            </div>
          ))}
        </div>
      </div>

      <div className="dmh-content1">
       
        <div className="categories-container1">
          <h2 className="section-title1">Categories</h2>
          <div className="categories-grid1">
        
            {categories1.map(category => (
              <div
                key={category.id}
                className={`category-card1 ${currentCategory1 === (category.slug || category.id) ? 'active1' : ''}`}
                onClick={() => handleCategorySelect1(category.id)}
              >
                <div className="category-icon1">{category.icon}</div>
                <h3 className="category-name1">{category.name}</h3>
                <p className="category-description1">{category.description}</p>
              </div>
            ))}

          </div>
        </div>

        {/* Featured Products component */}
        <div ref={featuredRef} id="featured-section">
          <FeaturedProducts currentCategory={currentCategory1} />
        </div>

        {/* Testimonials component */}
        <div ref={testimonialsRef} id="testimonials-section">
          <Testimonials />
        </div>

        {/* Live Hackathons component */}
        <div ref={hackathonsRef} id="hackathons-section">
          <LiveHackathons />
        </div>

        {/* Project Showcase component */}
        <div ref={showcaseRef} id="showcase-section">
          <ProjectShowcase />
        </div>
      </div>
    </div>
  );
}